import { Box, Flex, Image } from "@chakra-ui/react";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter/RichtextAdapter";
import type { AhTimelineItem } from "../AhTimeline.d";
import { decorationTriangleStyles, firstItemStyles } from "./TimeLineItem.styles";

export const TimeLineItem = ({ popoverText, logo, bottomText }: Omit<AhTimelineItem, "_uid">) => (
  <Flex pos="relative" _last={{ marginRight: 10 }} w={56} justify="center" sx={firstItemStyles}>
    <Box
      pos="absolute"
      bottom="220%"
      right="50%"
      transform="translateX(50%)"
      bg="white"
      w={40}
      borderRadius="lg"
      px={4}
      py={2}
      _after={decorationTriangleStyles}
    >
      <RichtextAdapter
        content={popoverText}
        customStyles={{ paragraph: { fontSize: "sm", color: "primary.800", textAlign: "center" } }}
      />
    </Box>
    <Image src={logo} />
    <Box pos="absolute" bottom="-150%" right="50%" transform="translateX(50%)" textAlign="center" w="fit-content">
      <RichtextAdapter content={bottomText} />
    </Box>
  </Flex>
);
